/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('Ticket', function($resource, $location, tickets_url) {
    const url    = `${tickets_url}/api/tasks/:id.json`;
    const params =
        {id: '@id'};

    const transformResponse = function(response) {
		try {
			const json = angular.fromJson(response);
			return json === null ? null : json.data;
		} catch (exception) {
			// this typically happen when a proxy returns HTML instead of the expected json response.
			return null;
		};
	};

    const actions = {
        query: {
            method:            'GET',
            isArray:           true,
            withCredentials:   true,
            transformResponse
        },
        get: {
            method:            'GET',
            isArray:           false,
            withCredentials:   true,
            transformResponse
        },
        getUnread: {
            method:            'GET',
            url:               `${tickets_url}/api/unread.json`,
            isArray:           false,
            withCredentials:   true,
            transformResponse
        },
        getUsers: {
            method:            'GET',
            url:               `${tickets_url}/api/users.json`,
            isArray:           false,
            withCredentials:   true
        },
        save: {
            method:         'POST',
            withCredentials: true,
            params: {
                title:   '@title',
                message: '@message',
                tags:    '@tags',
                users:   '@users'
            }
        },
        update: {
            method:          'PUT',
            withCredentials: true
        },
        close: {
            method:          'DELETE',
            withCredentials: true
        }
    };

    return $resource(url, params, actions);
});
